import types from 'pages/ComponentDivide/actions/types';
import { defaultPaging } from 'utils/helpers';

const INITIAL_STATE = {
  requestValue: {},
  componentDivideList: defaultPaging,
  componentDivideData: undefined,
  getListLoading: false,
  getDetailLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  ordersList: undefined,
  getOrdersLoading: false,
  componentDivideCode: undefined,
  getCodeLoading: false,
  detailOrder: undefined,
  getOrderLoading: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.SET_VALUE_REQUEST_ID_VALUE:
      return {
        ...state,
        requestValue: action.payload,
      };
    case types.GET_LIST_COMPONENTDIVIDE_REQUEST:
      return {
        ...state,
        getListLoading: true,
      };
    case types.GET_LIST_COMPONENTDIVIDE_SUCCESS: {
      return {
        ...state,
        componentDivideList: action.payload,
        getListLoading: false,
      };
    }
    case types.GET_LIST_COMPONENTDIVIDE_FAILURE:
      return {
        ...state,
        getListLoading: false,
      };
    case types.GET_DETAIL_COMPONENTDIVIDE_REQUEST:
      return {
        ...state,
        getDetailLoading: true,
      };
    case types.GET_DETAIL_COMPONENTDIVIDE_SUCCESS: {
      return {
        ...state,
        componentDivideData: action.payload,
        getDetailLoading: false,
      };
    }
    case types.GET_DETAIL_COMPONENTDIVIDE_FAILURE:
      return {
        ...state,
        getDetailLoading: false,
      };
    case types.CREATE_REQUEST:
      return {
        ...state,
        createLoading: true,
      };
    case types.CREATE_SUCCESS:
    case types.CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
      };
    case types.UPDATE_REQUEST:
      return {
        ...state,
        updateLoading: true,
      };
    case types.UPDATE_SUCCESS:
    case types.UPDATE_FAILURE:
      return {
        ...state,
        updateLoading: false,
      };
    case types.DELETE_REQUEST:
      return {
        ...state,
        deleteLoading: true,
      };
    case types.DELETE_SUCCESS:
    case types.DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
      };
    //get list product 
    case types.GET_LIST_PRODUCT_REQUEST:
      return {
        ...state,
        getOrdersLoading: true,
      };
    case types.GET_LIST_PRODUCT_SUCCESS: {
      return {
        ...state,
        ordersList: action.payload,
        getOrdersLoading: false,
      };
    }
    case types.GET_LIST_PRODUCT_FAILURE:
      return {
        ...state,
        getOrdersLoading: false,
      };

    //get code
    case types.GET_CODE_COMPONENTDIVIDE_REQUEST:
      return {
        ...state,
        getCodeLoading: true,
      };
    case types.GET_CODE_COMPONENTDIVIDE_SUCCESS: {
      return {
        ...state,
        componentDivideCode: action.payload,
        getCodeLoading: false,
      };
    }
    case types.GET_CODE_COMPONENTDIVIDE_FAILURE:
      return {
        ...state,
        getCodeLoading: false,
      };

    //get detail order
    case types.GET_ORDER_REQUEST:
      return {
        ...state,
        getOrderLoading: true,
      };
    case types.GET_ORDER_SUCCESS: {
      return {
        ...state,
        detailOrder: action.payload,
        getOrderLoading: false,
      };
    }
    case types.GET_ORDER_FAILURE:
      return {
        ...state,
        getOrderLoading: false,
      };

    default:
      return state;
  }
}
